import React, { ReactNode } from "react";
import Accordion, { AccordionItem } from "@ingka/accordion";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/accordion/dist/style.css";
import "@ingka/focus/dist/style.css";

type TransitionEventCallback<T> = (event: T, isOpen: boolean) => void;

type FixaAccordionItemProps = {
  id: string;
  title: string | React.ReactElement;
  children: ReactNode;
  subtle?: boolean;
  onHeadingClicked?: () => void;
  onClick?: () => void;
  open?: boolean;
  className?: string;
  caption?: string;
  onTransitionEnd?: TransitionEventCallback<React.TransitionEvent>;
};

const FixaAccordionItem: React.FC<FixaAccordionItemProps> = (props) => {
  return <AccordionItem {...props} />;
};

type FixaAccordionProps = {
  children: ReactNode;
  collapsible?: boolean;
  className?: string;
  padded?: boolean;
  size?: "small" | "medium" | "large";
};

const FixaAccordion: React.FC<FixaAccordionProps> = (props) => {
  return <Accordion {...props} />;
};

export { FixaAccordion, FixaAccordionItem };
